import { useDispatch } from 'react-redux'

import type { StoreDispatch } from '@app/store/dispatch'

export const useAppDispatch = () => useDispatch<StoreDispatch>()
